import axios from 'axios';
import router from '../router';

let state = {

    manual: false,

    // frame
    frame_Data: {},
    horizontalDistance_Minimum: null,
    horizontalDistance_Maximum: null,
    wrappingAngleFrameCalculation_Modal_Shown: false,
    frameInformation: null,

    wrappingAngleCalculation_Modal_Shown: false,
    loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown: false,
    loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown: false,
    cancellationInformationsAboutHttpRequests_get_wrappingAngleCalculation_Informations: new AbortController(),
    cancellationInformationsAboutHttpRequests_check_wrappingAngleCalculation_Data_byCalculationDll: new AbortController(),

    verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley: { value: undefined, invalid: undefined },
    horizontalDistanceOfTheRopeHoles: { value: undefined, invalid: undefined },
    deflectionPulleyDiameter: { value: undefined, invalid: undefined },
    wrappingAngle_Calculated: undefined,
    calculated_wrappingAngle: undefined,
    entered_wrappingAngle: { value: undefined, invalid: undefined },
    wrappingAngleCalculation_Inputs_Invalid: null,
}


const actions = {
    set_decimalValue({ dispatch }, value) {
        const valueDecimalCriteria = this._vm.$localDecimal;
        valueDecimalCriteria.value = value.value;
        if (value.country == 'de') {
            valueDecimalCriteria.country = 'de-DE';
        }
        else {
            valueDecimalCriteria.country = 'en-US';
        }

        const decimalValue = this._vm.$set_decimalValueToLocaleString(valueDecimalCriteria);

        if (value.name == 'verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley') {
            dispatch('change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeAction', decimalValue);
        }
        else if (value.name == 'horizontalDistanceOfTheRopeHoles') {
            if (state.wrappingAngleFrameCalculation_Modal_Shown == true || state.manual == true) {
                dispatch('change_horizontalDistanceOfTheRopeHoles2_storeAction', decimalValue);
            }
            else {
                dispatch('change_horizontalDistanceOfTheRopeHoles_storeAction', decimalValue);
            }
        }
        else if (value.name == 'entered_wrappingAngle') {
            dispatch('change_entered_wrappingAngle_storeAction', decimalValue);
        }
    },




    change_elevatorMotor_Frame_toDefault_storeAction({ commit }) {
        commit('change_frame_Data_storeMutation', []);
        commit('change_frame_horizontalDistance_Minimum_storeMutation', null);
        commit('change_frame_horizontalDistance_Maximum_storeMutation', null);
        commit('change_wrappingAngleFrameCalculation_Modal_Shown_storeMutation', false);
        commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', false);
        commit('change_frameInformation_storeMutation', null);
    },

    change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeAction({ commit, dispatch }, value) {
        const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
        valueAndValueValidationCriteria.value = value;
        valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
        valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
        const verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

        commit('change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeMutation', verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_ValidationResult);
        dispatch('checkIf_wrappingAngleCalculation_Inputs_areValid_storeAction')
    },
    change_horizontalDistanceOfTheRopeHoles_storeAction({ commit, dispatch }, value) {
        const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
        valueAndValueValidationCriteria.value = value;
        valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
        valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
        const horizontalDistanceOfTheRopeHoles_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

        commit('change_horizontalDistanceOfTheRopeHoles_storeMutation', horizontalDistanceOfTheRopeHoles_ValidationResult);
        dispatch('checkIf_wrappingAngleCalculation_Inputs_areValid_storeAction')
    },
    change_horizontalDistanceOfTheRopeHoles2_storeAction({ commit, dispatch }, value) {
        const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
        valueAndValueValidationCriteria.value = value;
        valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
        valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.value = state.horizontalDistance_Minimum;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.value = state.horizontalDistance_Maximum;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = this._vm.$operators.lessThanOrEqualTo;
        const horizontalDistanceOfTheRopeHoles_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

        commit('change_horizontalDistanceOfTheRopeHoles_storeMutation', horizontalDistanceOfTheRopeHoles_ValidationResult);
        dispatch('checkIf_wrappingAngleCalculation_Inputs_areValid_storeAction')
    },
    change_deflectionPulleyDiameter_storeAction({ commit, dispatch }, value) {
        const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
        valueAndValueValidationCriteria.value = value;
        valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.integer;
        valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = null;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
        const deflectionPulleyDiameter_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

        commit('change_deflectionPulleyDiameter_storeMutation', deflectionPulleyDiameter_ValidationResult);
        dispatch('checkIf_wrappingAngleCalculation_Inputs_areValid_storeAction')
    },

    checkIf_wrappingAngleCalculation_Inputs_areValid_storeAction({ commit, dispatch }) {
        if ((state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.invalid == false) && (state.horizontalDistanceOfTheRopeHoles.invalid == false) && (state.deflectionPulleyDiameter.invalid == false)) {
            commit('change_wrappingAngleCalculation_Inputs_Invalid_storeMutation', false);
            if (state.manual == true) {
                dispatch('get_wrappingAngleCalculation_Informations_Manual_storeAction', true);
            }
            else {
                dispatch('get_wrappingAngleCalculation_Informations_storeAction', true);
            }
        }
        else {
            commit('change_wrappingAngleCalculation_Inputs_Invalid_storeMutation', true);
            this.commit('driveTechnologies/abort_httpRequests_get_wrappingAngleCalculation_Informations_storeMutation');
        }
    },


    change_entered_wrappingAngle_storeAction({ commit }, value) {
        const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
        valueAndValueValidationCriteria.value = value;
        valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
        valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
        valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThan;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
        valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
        const entered_wrappingAngle_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

        commit('change_entered_wrappingAngle_storeMutation', entered_wrappingAngle_ValidationResult);
    },

    async get_wrappingAngleCalculation_Informations_storeAction({ rootState, commit, dispatch }, inputs_Transmitted) {
        commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
        var suspensionMeans = {};
        if (inputs_Transmitted == true) {
            commit('change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation', true);

            suspensionMeans.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley = state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value;
            suspensionMeans.horizontalDistanceOfTheRopeHoles = state.horizontalDistanceOfTheRopeHoles.value;
            suspensionMeans.deflectionPulleyDiameter = state.deflectionPulleyDiameter.value;
        }
        else {
            commit('change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
        }

        var frames = null;
        if (state.frame_Data.hasOwnProperty('frame_Selection') && state.frame_Data.frame_Selection.length > 0) {
            const firstIndex_frameSelected = state.frame_Data.frame_Selection.findIndex(i => (i.selected == true))

            if (firstIndex_frameSelected > -1) {
                frames = state.frame_Data.frame_Selection[firstIndex_frameSelected].frame;
            }

        }
        const data = {
            configurationOverviewsId: rootState.configurations.configurationOverviewsId,
            suspensionMeans: suspensionMeans,
            elevatorMotor_TractionSheave: rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_TractionSheave,
            elevatorMotor_Machine: rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_Machine,
            wrappingAngleFrameCalculationModal_Shown: state.wrappingAngleFrameCalculation_Modal_Shown,
            inputs_Transmitted: inputs_Transmitted,
            frame: frames,
        }

        this.commit('driveTechnologies/abort_httpRequests_get_wrappingAngleCalculation_Informations_storeMutation');
        if (rootState.driveTechnologies.cancellationInformationsAboutHttpRequests_get_wrappingAngleCalculation_Informations.signal.aborted == true) {
            this.commit('driveTechnologies/change_cancellationInformationsAboutHttpRequests_get_wrappingAngleCalculation_Informations_toNewAbortController_storeMutation')
        }
        await axios({
            method: 'post',
            url: '/api/driveTechnologies/get_wrappingAngleCalculation_Informations',
            signal: rootState.driveTechnologies.cancellationInformationsAboutHttpRequests_get_wrappingAngleCalculation_Informations.signal,
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data)
                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_wrappingAngleCalculation_Informations_storeAction', response.data.data)
                }
                commit('change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);
            })
            .catch((error) => {})
            .then(() => {
                commit('change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);

            })
    },

    async get_wrappingAngleCalculation_Informations_Manual_storeAction({ rootState, commit, dispatch }, inputs_Transmitted) {
        commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
        var avum = null;
        var asl = null;
        var urd = null;
        if (inputs_Transmitted == true) {
            commit('change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
            avum = state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value;
            asl = state.horizontalDistanceOfTheRopeHoles.value;
            urd = state.deflectionPulleyDiameter.value;
        }
        else {
            commit('change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
        }

        var frames = null;
        if (state.frame_Data.hasOwnProperty('frame_Selection') && state.frame_Data.frame_Selection.length > 0) {
            const firstIndex_frameSelected = state.frame_Data.frame_Selection.findIndex(i => (i.selected == true))

            if (firstIndex_frameSelected > -1) {
                frames = state.frame_Data.frame_Selection[firstIndex_frameSelected].frame;
            }

        }
        var motorSelected = (state.frameManual.motorData != null) ? true : false


        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            avum: avum,
            asl: asl,
            urd: urd,
            inputs_Transmitted: inputs_Transmitted,
            frame: frames,
            motorSelected: motorSelected,
        }

        await axios({
            method: 'post',
            url: '/api/frameManual/get_wrappingAngleCalculation_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data)
                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_wrappingAngleCalculation_Informations_storeAction', response.data.data)
                }
                commit('change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);
            })
            .catch(() => { })
            .then(() => {
                commit('change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);

            })
    },


    toDos_afterResponseOf_get_wrappingAngleCalculation_Informations_storeAction({ commit, dispatch, rootState }, value) {
        commit('change_calculated_wrappingAngle_storeMutation', value.calculated_WrappingAngle);
        if (value.inputs_Transmitted == false) {
            commit('change_deflectionPulleyDiameter_storeMutation', { value: value.deflectionPulleyDiameter, invalid: false });
            dispatch('change_wrappingAngleFrameCalculation_Modal_Shown_storeAction', value.wrappingAngleFrameCalculation_Modal_Shown)
            if (state.manual == false) {
                dispatch('get_frame_Informations_storeAction', rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade);
            }
        }
    },

    async get_allFrameDetails_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        var frames = null;
        if (state.frame_Data.hasOwnProperty('frame_Selection') && state.frame_Data.frame_Selection.length > 0) {
            const firstIndex_frameSelected = state.frame_Data.frame_Selection.findIndex(i => (i.selected == true))

            if (firstIndex_frameSelected > -1) {
                frames = state.frame_Data.frame_Selection[firstIndex_frameSelected].frame;
            }
        }
        var motorSelected = (state.frameManual.motorData != null) ? true : false

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            frame: frames,
            motorSelected: motorSelected,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_allFrameDetails',
            data: {
                data: data,
            }
        })
            .then((response) => {
                if (response.data.valid == true) {
                    this.commit('frameManual/change_urdSelection_storeMutation', response.data.urdSelection);
                    const firstIndex_whichMeetConditions = rootState.frameManual.urdSelection.findIndex(i => (i.selected == true));
                    if (firstIndex_whichMeetConditions > -1) {
                        this.commit('frameManual/change_urdSelected_storeMutation', rootState.frameManual.urdSelection[firstIndex_whichMeetConditions].value);
                    }
                    this.commit('frameManual/change_positionInformation_storeMutation', response.data.positionInformation);
                    this.commit('frameManual/change_positionUniversal_storeMutation', rootState.frameManual.positionInformation.universalDefault);
                    this.commit('frameManual/change_positionLeft_storeMutation', rootState.frameManual.positionInformation.leftDefault);
                    this.commit('frameManual/change_positionRight_storeMutation', rootState.frameManual.positionInformation.rightDefault);
                    this.commit('frameManual/change_frameDetails_storeMutation', response.data.frameDetails);
                    this.dispatch('frameManual/get_urzSelection_storeAction');
                    this.dispatch('frameManual/get_frameOptions_storeAction');
                }
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
    async get_frame_Informations_storeAction({ dispatch, rootState }, value) {
        const data = {
            configurationOverviewsId: rootState.configurations.configurationOverviewsId,
            configurationSteps: rootState.configurations.configurationSteps,
            elevatorMotor_TractionSheave: value.elevatorMotor_TractionSheave,
            elevatorMotor_Machine: value.elevatorMotor_Machine,

        }

        await axios({
            method: 'post',
            url: '/api/frames/get_frame_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_frame_Informations_storeAction', response.data.data)
                }
            })
            .catch(() => { })
    },


    async get_frame_Informations_Manual_storeAction({ dispatch, rootState }, value) {
        var fraart = (rootState.frameManual.selectedFraart != null && rootState.frameManual.selectedFraart.hasOwnProperty('text')) ? rootState.frameManual.selectedFraart.text.text : null;
        var fratyp = (rootState.frameManual.selectedFratyp != null && rootState.frameManual.selectedFratyp.hasOwnProperty('text')) ? rootState.frameManual.selectedFratyp.text.text : null;
        var motorSelected = (state.frameManual.motorData != null) ? true: false

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            fraart: fraart,
            fratyp: fratyp,
            motorSelected: motorSelected,
        };

        await axios({
            method: 'post',
            url: '/api/frameManual/get_frameManual_Informations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    dispatch('toDos_afterResponseOf_get_frame_Informations_Manual_storeAction', response.data.data)
                }
            })
            .catch(() => { })
    },


    toDos_afterResponseOf_get_frame_Informations_storeAction({ dispatch }, value) {
        dispatch('change_frame_Data_storeAction', value.frame_Data);

        value.configurationSteps.frame.loaded = true;
        this.dispatch('configurations/change_configurationSteps_storeAction', value.configurationSteps);
    },

    toDos_afterResponseOf_get_frame_Informations_Manual_storeAction({ dispatch }, value) {
        dispatch('change_frame_Data_storeAction', value.frame_Data);
    },


    change_frame_Data_storeAction({ commit, dispatch }, value) {
        commit('change_frame_Data_storeMutation', value);
    },

    async checkIf_changesAt_frame_changes_configurationFlow_storeAction({ rootState, commit, dispatch }, value) {
        const firstIndex_whichMeetCondition = state.frame_Data.frame_Selection.findIndex(i => i.frame.blockNumber == value.frame.blockNumber);
        if (firstIndex_whichMeetCondition > -1) {
            const firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue = state.frame_Data.frame_Selection.findIndex(i => i.selected == true);
            dispatch('change_Selected_atElementOf_frame_Selection_storeAction', firstIndex_whichMeetCondition)
            dispatch('change_frame_horizontalDistance_Minimum_storeAction', state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.horizontalDistanceMinimum);
            dispatch('change_frame_horizontalDistance_Maximum_storeAction', state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.horizontalDistanceMaximum);

            dispatch('change_deflectionPulleyDiameter_storeAction', state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.pulleyDiameter);
            const localDecimal = { value: state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.verticalDistance, country: rootState.configurations.language, name: 'verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley' }
            dispatch('set_decimalValue', localDecimal);
            if (firstIndexWhere_Selected_atElementOf_frame_Selection_isTrue != firstIndex_whichMeetCondition) {
                if (state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.horizontalDistanceMaximum != null && state.frame_Data.frame_Selection[firstIndex_whichMeetCondition].frame.horizontalDistanceMaximum == 0) {
                    const localDecimal2 = { value: 0, country: rootState.configurations.language, name: 'horizontalDistanceOfTheRopeHoles' }
                    dispatch('set_decimalValue', localDecimal2);
                }
                else {
                    dispatch('change_horizontalDistanceOfTheRopeHoles2_storeAction', undefined);
                }
            }
        }
        else {
        }
    },

    change_Selected_atElementOf_frame_Selection_storeAction({ commit }, value) {
        commit('change_Selected_at_frame_Selection_storeMutation', value)
    },

    change_frame_horizontalDistance_Minimum_storeAction({ commit }, value) {
        commit('change_frame_horizontalDistance_Minimum_storeMutation', value);
    },
    change_frame_horizontalDistance_Maximum_storeAction({ commit }, value) {
        commit('change_frame_horizontalDistance_Maximum_storeMutation', value);
    },

    async check_frame_numberOfPulleys_storeAction({ commit, rootState }, value) {
        const data = {
            configurationOverviewsId: rootState.configurations.configurationOverviewsId,
            frame: value,
        }

        await axios({
            method: 'post',
            url: '/api/driveTechnologies/check_frame_numberOfPulleys',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                commit('change_frameInformation_storeMutation', response.data);
            })
            .catch(() => { })

    },

    change_wrappingAngleFrameCalculation_Modal_Shown_storeAction({ commit }, value) {
        commit('change_frameInformation_storeMutation', null);
        commit('change_wrappingAngleFrameCalculation_Modal_Shown_storeMutation', value)
    },



    // wrappingAngle
    change_wrappingAngleCalculation_toDefault_storeAction({ commit }) {
        commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', false)

        this.commit('driveTechnologies/abort_httpRequests_get_wrappingAngleCalculation_Informations_storeMutation');
        this.commit('driveTechnologies/abort_httpRequests_check_wrappingAngleCalculation_Data_byCalculationDll_storeMutation');

        this.commit('driveTechnologies/change_elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade_storeMutation', {});

        commit('change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);
        commit('change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation', false);

        commit('change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeMutation', { value: undefined, invalid: undefined });
        commit('change_horizontalDistanceOfTheRopeHoles_storeMutation', { value: undefined, invalid: undefined });
        commit('change_deflectionPulleyDiameter_storeMutation', { value: undefined, invalid: undefined });
        commit('change_wrappingAngle_Calculated_storeMutation', undefined);
        commit('change_calculated_wrappingAngle_storeMutation', undefined);
        commit('change_entered_wrappingAngle_storeMutation', { value: undefined, invalid: undefined });
        commit('change_wrappingAngleCalculation_Inputs_Invalid_storeMutation', undefined);

        this.commit('driveTechnologies/change_wrappingAngle_Property_of_suspensionMeans_Object_atItemOf_elevatorMotor_Machine_Selection_EnteredNotCalculated_storeMutation', undefined);
    },

    get_wrappingAngleCalculation_Object_fromItemOf_elevatorMotor_Machine_Selection_storeAction({ commit }, selected_elevatorMotor_Machine) {
        commit('change_wrappingAngle_Calculated_storeMutation', selected_elevatorMotor_Machine.suspensionMeans.wrappingAngleCalculated)

        commit('change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeMutation', { value: selected_elevatorMotor_Machine.suspensionMeans.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley, invalid: false });
        commit('change_horizontalDistanceOfTheRopeHoles_storeMutation', { value: selected_elevatorMotor_Machine.suspensionMeans.horizontalDistanceOfTheRopeHoles, invalid: false });
        commit('change_deflectionPulleyDiameter_storeMutation', { value: selected_elevatorMotor_Machine.suspensionMeans.deflectionPulleyDiameter, invalid: false });
        commit('change_wrappingAngleCalculation_Inputs_Invalid_storeMutation', false);

        if (selected_elevatorMotor_Machine.suspensionMeans.wrappingAngleCalculated == true) {
            commit('change_calculated_wrappingAngle_storeMutation', selected_elevatorMotor_Machine.suspensionMeans.wrappingAngle);
            commit('change_entered_wrappingAngle_storeMutation', { value: null, invalid: false });
        }
        else if (selected_elevatorMotor_Machine.suspensionMeans.wrappingAngleCalculated == false) {
            commit('change_calculated_wrappingAngle_storeMutation', null);
            commit('change_entered_wrappingAngle_storeMutation', { value: selected_elevatorMotor_Machine.suspensionMeans.wrappingAngle, invalid: false });
        }
    },

    backTo_wrappingAngle_Modal_storeAction({ commit }) {
        this.commit('driveTechnologies/change_tractionCheck_Modal_Shown_storeMutation', false);
        commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', true);
    },
    change_wrappingAngleCalculation_Modal_Shown_storeAction({ commit, dispatch, rootState }, value) {
        if (value == true) {
            commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', value)
        }
        else if (value == false) {
            if (rootState.driveTechnologies.elevatorMotor_Machine_Selection_Shown == true) {
                dispatch('checkIf_changesAt_wrappingAngleCalculation_changes_configurationFlow_storeAction')
            }
            else {
                dispatch('change_wrappingAngleCalculation_toDefault_storeAction')
            }
        }
    },

    checkIf_changesAt_wrappingAngleCalculation_changes_configurationFlow_storeAction({ rootState, dispatch }) {
        if (rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.tractionCheck_Executed == true) {
            var inputs_Changed = false;

            if (rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.wrappingAngleCalculated == true) {
                if ((rootState.frameModal.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value != rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley)
                    || (rootState.frameModal.horizontalDistanceOfTheRopeHoles.value != rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.horizontalDistanceOfTheRopeHoles)
                    || (rootState.frameModal.deflectionPulleyDiameter.value != rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.deflectionPulleyDiameter)
                ) {
                    inputs_Changed = true;
                }
            }
            else if (rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.wrappingAngleCalculated == false) {
                if (rootState.frameModal.entered_wrappingAngle.value != rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.suspensionMeans.wrappingAngle) {
                    inputs_Changed = true;
                }
            }


            if (inputs_Changed == true) {
                if (rootState.frameModal.wrappingAngleCalculation_Inputs_Invalid == true) {
                    this.dispatch('driveTechnologies/delete_wrappingAngleCalculation_and_tractionCheck_Data_at_itemOf_elevatorMotor_Machine_Selection_storeAction')
                    this.dispatch('driveTechnologies/change_Selected_atEveryElementOf_elevatorMotor_Machine_Selection_toFalse_storeAction')
                }

                if (rootState.configurations.configurationSteps.elevatorMotor_Machine.storedInDatabase == true) {
                    this.dispatch('configurations/selectAndInsert_or_updateAndOrDelete_databaseRecords_storeAction', { changesAt: this._vm.$configurationSteps.wrappingAngleCalculaion });

                }
            }
        }

        dispatch('change_wrappingAngleCalculation_toDefault_storeAction')
    },

    change_wrappingAngle_Calculated_storeAction({ commit, dispatch, rootState }, value) {
        commit('change_wrappingAngle_Calculated_storeMutation', value);
        if ((state.wrappingAngle_Calculated == true) && (rootState.driveTechnologies.wrappingAngle_Property_of_suspensionMeans_Object_atItemOf_elevatorMotor_Machine_Selection_EnteredNotCalculated == true)) {
            this.commit('driveTechnologies/change_wrappingAngle_Property_of_suspensionMeans_Object_atItemOf_elevatorMotor_Machine_Selection_EnteredNotCalculated_storeMutation', false);
            dispatch('get_wrappingAngleCalculation_Informations_storeAction', false);
        }
    },


    checkIf_wrappingAngleCalculation_Data_areValid_storeAction({ dispatch, rootState }) {
        if (state.wrappingAngle_Calculated == true) {
            if (state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.invalid == null) {
                dispatch('change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeAction', state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value);
            }
            if (state.horizontalDistanceOfTheRopeHoles.invalid == null) {
                dispatch('change_horizontalDistanceOfTheRopeHoles_storeAction', state.horizontalDistanceOfTheRopeHoles.value);
            }
            if (state.deflectionPulleyDiameter.invalid == null) {
                dispatch('change_deflectionPulleyDiameter_storeAction', state.deflectionPulleyDiameter.value);
            }

            if ((state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.invalid == false) && (state.horizontalDistanceOfTheRopeHoles.invalid == false) && (state.deflectionPulleyDiameter.invalid == false) && (state.calculated_wrappingAngle != null)) {
                dispatch('check_wrappingAngleCalculation_Data_byCalculationDll_storeAction');
            }
        }
        else if (state.wrappingAngle_Calculated == false) {
            if (state.entered_wrappingAngle.invalid == null) {
                dispatch('change_entered_wrappingAngle_storeAction', state.entered_wrappingAngle.value);
            }

            if (state.entered_wrappingAngle.invalid == false) {
                dispatch('check_wrappingAngleCalculation_Data_byCalculationDll_storeAction');
            }
        }
    },

    check_wrappingAngleCalculation_Data_byCalculationDll_storeAction({ rootState, commit, dispatch }) {
        var suspensionMeans = {
            verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley: state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley.value,
            horizontalDistanceOfTheRopeHoles: state.horizontalDistanceOfTheRopeHoles.value,
            deflectionPulleyDiameter: state.deflectionPulleyDiameter.value,
            wrappingAngleCalculated: state.wrappingAngle_Calculated,
        };

        if (state.wrappingAngle_Calculated == true) {
            suspensionMeans.wrappingAngle = state.calculated_wrappingAngle;
        }
        else if (state.wrappingAngle_Calculated == false) {
            suspensionMeans.wrappingAngle = state.entered_wrappingAngle.value;
        }

        var frames = null;
        if (state.frame_Data.hasOwnProperty('frame_Selection') && state.frame_Data.frame_Selection.length > 0) {
            const firstIndex_frameSelected = state.frame_Data.frame_Selection.findIndex(i => (i.selected == true))

            if (firstIndex_frameSelected > -1) {
                frames = state.frame_Data.frame_Selection[firstIndex_frameSelected].frame;
            }

        }

        const data = {
            configurationOverviewsId: rootState.configurations.configurationOverviewsId,
            elevatorMotor_TractionSheave: rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_TractionSheave,
            elevatorMotor_Machine: rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_Machine,
            suspensionMeans: suspensionMeans,
            frame: frames,
        }

        this.commit('driveTechnologies/abort_httpRequests_check_wrappingAngleCalculation_Data_byCalculationDll_storeMutation');
        if (rootState.driveTechnologies.cancellationInformationsAboutHttpRequests_check_wrappingAngleCalculation_Data_byCalculationDll.signal.aborted == true) {
            this.commit('driveTechnologies/change_cancellationInformationsAboutHttpRequests_check_wrappingAngleCalculation_Data_byCalculationDll_toNewAbortController_storeMutation')
        }

        axios({
            method: 'post',
            url: '/api/driveTechnologies/check_wrappingAngleCalculation_Data_byCalculationDll',
            signal: rootState.driveTechnologies.cancellationInformationsAboutHttpRequests_check_wrappingAngleCalculation_Data_byCalculationDll.signal,
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data)

                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    if (response.data.data.axleLoad != null) {
                        const firstIndex_whichMeetConditions = rootState.driveTechnologies.elevatorMotor_Machine_Data.elevatorMotor_Machine_Selection.findIndex(i => (i.elevatorMotor_Machine.blockNumberMachine == rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_Machine.blockNumberMachine) && (i.elevatorMotor_Machine.blockNumberGear == rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_Machine.blockNumberGear) && (i.elevatorMotor_TractionSheave.blockNumber == rootState.driveTechnologies.elevatorMotor_Machine_forWhich_wrappingAngleCalculation_and_tractionCheck_isMade.elevatorMotor_TractionSheave.blockNumber))
                        if (firstIndex_whichMeetConditions > -1) {
                            this.commit('driveTechnologies/change_axleLoad_at_ElementOf_elevatorMotor_Machine_Selection_storeMutation', { index: firstIndex_whichMeetConditions, axleLoad: response.data.data.axleLoad })
                        }
                    }

                    this.dispatch('driveTechnologies/toDos_afterResponseOf_check_wrappingAngleCalculation_Data_byCalculationDll_storeAction')
                }
            })
            .then(() => {
                commit('change_wrappingAngleCalculation_Modal_Shown_storeMutation', false);
            })
    },


}

const mutations = {
    // wrappingAngleCalculation
    change_wrappingAngleCalculation_Modal_Shown_storeMutation(state, payload) {
        state.wrappingAngleCalculation_Modal_Shown = payload;
    },
    change_loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown_storeMutation(state, payload) {
        state.loader_forLoadingAllContent_at_wrappingAngleCalculation_Modal_Shown = payload;
    },
    change_loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown_storeMutation(state, payload) {
        state.loader_forLoadingResults_at_wrappingAngleCalculation_Modal_Shown = payload;
    },

    change_verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley_storeMutation(state, payload) {
        state.verticalDistanceOfTheAxlesFromTractionSheaveAndDeflectionPulley = payload;
    },
    change_horizontalDistanceOfTheRopeHoles_storeMutation(state, payload) {
        state.horizontalDistanceOfTheRopeHoles = payload;
    },
    change_deflectionPulleyDiameter_storeMutation(state, payload) {
        state.deflectionPulleyDiameter = payload;
    },
    change_wrappingAngleCalculation_Inputs_Invalid_storeMutation(state, payload) {
        state.wrappingAngleCalculation_Inputs_Invalid = payload;
    },
    change_wrappingAngle_Calculated_storeMutation(state, payload) {
        state.wrappingAngle_Calculated = payload;
    },
    change_calculated_wrappingAngle_storeMutation(state, payload) {
        state.calculated_wrappingAngle = payload;
    },
    change_entered_wrappingAngle_storeMutation(state, payload) {
        state.entered_wrappingAngle = payload;
    },
    // frame
    change_frame_Data_storeMutation(state, payload) {
        state.frame_Data = Object.assign({}, payload);
    },
    change_frameInformation_storeMutation(state, payload) {
        state.frameInformation = payload;
    },
    change_Selected_at_frame_Selection_storeMutation(state, payload) {
        for (let i = 0; i < state.frame_Data.frame_Selection.length; i++) {
            state.frame_Data.frame_Selection[i].selected = false;
            if (i == payload) {
                state.frame_Data.frame_Selection[i].selected = true;
            }
        }
    },
    change_Selected_atEveryElementOf_frame_Selection_toFalse_storeMutation(state) {
        if (Array.isArray(state.frame_Data.frame_Selection)) {
            state.frame_Data.frame_Selection.forEach(i => {
                i.selected = false;
            })
        }
    },

    change_frame_horizontalDistance_Minimum_storeMutation(state, payload) {
        state.horizontalDistance_Minimum = payload;
    },
    change_frame_horizontalDistance_Maximum_storeMutation(state, payload) {
        state.horizontalDistance_Maximum = payload;
    },
    change_wrappingAngleFrameCalculation_Modal_Shown_storeMutation(state, payload) {
        state.wrappingAngleFrameCalculation_Modal_Shown = payload;
    },
    change_manual_storeMutation(state, payload) {
        state.manual = payload;
    }
}

export const frameModal = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations
}